// extracted by mini-css-extract-plugin
export var callout = "callout-module--callout--dd182";
export var calloutDark = "callout-module--callout--dark--9af88";
export var callout__content = "callout-module--callout__content--4b1a0";
export var callout__headline = "callout-module--callout__headline--49fbe";
export var callout__img = "callout-module--callout__img--b4387";
export var callout__imgPad = "callout-module--callout__img--pad--ef045";
export var callout__link = "callout-module--callout__link--1720e";
export var mt0 = "callout-module--mt-0--52230";
export var mt1 = "callout-module--mt-1--bd303";
export var mt2 = "callout-module--mt-2--ef344";
export var mt3 = "callout-module--mt-3--69c32";
export var mt4 = "callout-module--mt-4--d8a29";
export var mt5 = "callout-module--mt-5--65242";
export var mt6 = "callout-module--mt-6--1875e";